// Types
import { RootState } from 'types/RootState.types';

// Config
import featureConstants, { DISABLED_FEATURE } from '@constants/featureConstants';
import { isFeatureActive, isFeatureDisabled } from '@redux/reducers/config/configReducer';

export const shouldShowApplePayFeature = (state: RootState): boolean => {
  const isDisabled =
    isFeatureDisabled(state, DISABLED_FEATURE.APPLE_PAY) || isFeatureActive(state, featureConstants.DISABLE_APPLE_PAY);

  return !isDisabled;
};
